module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/937814f79522ddaecdc306375c7330af.png";